import React, { useState, useEffect } from 'react';
import './Header.scss';
import axios from 'axios';

export const Header = () => {
  const [header, setHeader] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_LEGACY_BASE_HOST}/Utility/Header`)
      .then((response) => {
        setHeader(response.data);
      });
  }, []);
  return (
    <header id="header" className="ph-header-main header-container" dangerouslySetInnerHTML={{ __html: header }}>
    </header>
  );
};
